import request from "@/utils/request";
import qs from "qs";

/**
 * 查询商品列表
 * @param params
 * @returns {*}
 */
export function getGoodsList(params) {
  return request({
    url: "/goods/getList",
    method: "get",
    params
  });
}

/**
 * 查询商品列表【导出】
 * @param params
 * @returns {*}
 */
export function exportGoodsList(params) {
  return request({
    url: "/goods/exportList",
    method: "get",
    responseType: "blob", // 重要：设置responseType为'blob'以处理二进制数据
    params
  });
}

/**
 * 查询商品预览详情
 * @param params
 * @returns {*}
 */
export function getGoodsPreviewDetail(params) {
  return request({
    url: "/goods/getGoodsPreviewDetail",
    method: "get",
    params
  });
}

/**
 * 查询商品编辑详情
 * @param params
 * @returns {*}
 */
export function getGoodsEditDetail(params) {
  return request({
    url: "/goods/getGoodsEditDetail",
    method: "get",
    params
  });
}

/**
 * 新增-编辑商品
 * @param params
 * @returns {*}
 */
export function editGoods(params) {
  return request.post("/goods/editGoods", qs.stringify(params));
}

/**
 * 上架-下架商品
 * @param params
 * @returns {*}
 */
export function upDownGoods(params) {
    return request.post("/goods/upDownGoods", qs.stringify(params));
}

/**
 * 删除-恢复商品
 * @param params
 * @returns {*}
 */
export function deleteGoods(params) {
    return request.post("/goods/deleteGoods", qs.stringify(params));
}

/**
 * 审核商品
 * @param params
 * @returns {*}
 */
export function checkGoods(params) {
  return request.post("/goods/checkGoods", qs.stringify(params));
}

/**
 * 查询可赠送的赠品
 * @param params
 * @returns {*}
 */
export function getGiftConfigs(params) {
  return request({
    url: "/goods/getGiftConfigs",
    method: "get",
    params
  });
}
